export default __webpack_public_path__ + "static/media/banner_bg_desktop_lg.7fbc69ac.svg";